import { ApolloClient } from '@apollo/client'
import { actionTypes } from './index'
import createFetchSaga from '@utils/store/createFetchSaga'
import usersGetQuery from '@queries/usersGetQuery'
import { sagaDebounce } from '@store/helpers'

const fetchList = async (client: ApolloClient<any>, action: Action): Promise<any> => {
  return client
    .query({ query: usersGetQuery, variables: { ...action.payload, nested: true } })
    .then(({ data }) => ({ data: data?.usersGet }))
}

export default function* watch(): Generator {
  if (typeof window === 'undefined') return // dont run on SSR
  yield sagaDebounce(200, actionTypes.run, createFetchSaga(actionTypes.run, fetchList))
}
